import _ from 'lodash';
import { Steps, StepActions } from '../../../components/common/wizard/logic';
import EventResult from '../components/finalStandings';
import PostEventSetup from '../components/setup';
import RecordAdvancersAlternates from '../components/recordAthletes';
import PayFees from '../components/fees';
import { wizardSteps, STEP_SEQUENCE } from './';

export const getSteps = function(lastStep) {
    const steps = new Steps();
 
    wizardSteps.map((step) => {
				const { label,sequence } = step;
		
				const currentStep = ((lastStep > 0) && (lastStep === sequence)) ? true:false;
				let currentStepDisabled = true;
				let currentStepCompleted = false;

				if((sequence <= lastStep) && (!currentStep))
				{
					currentStepDisabled = false;
					currentStepCompleted = true;
				}
		steps.add(label,currentStep,currentStepDisabled,currentStepCompleted,sequence);
		})
		return steps;
}


export const getWizardComponent = function(currentStep) {
	switch(currentStep) {
		case(STEP_SEQUENCE.UploadFinalStandings):
		{
			return EventResult; 
		}
		case(STEP_SEQUENCE.PostEventSetup):
		{
			return PostEventSetup;
		}
		case(STEP_SEQUENCE.Advancers):
		{
			return RecordAdvancersAlternates;
		}
		case(STEP_SEQUENCE.FeePayment):
		{
			return PayFees;
		}
	}
}

export const goToStep = function(stepAction, wizardsteps, step) {
	// step is the step in the wizard to go to
	const steps = [...wizardsteps];

	// update current and next steps accordingly
	const currentStep = _.find(steps, { 'current': true });
	currentStep.completed = true;
	currentStep.current   = false;
	currentStep.disabled  = false;
	const currentSequence = currentStep.sequence

	let next=0;

	switch(stepAction) {
		case(StepActions.Previous):
		{
			next = currentSequence - 1;
			break;
		}
		case(StepActions.Next):
		{
			next = currentSequence + 1;
			break;
		}
		case(StepActions.GoTo):
		{
			next = parseInt(step,10); 
			break;
		}
	}

	const nextStep = _.find(steps, { 'sequence': next });
	nextStep.completed = false;
	nextStep.current   = true;
	nextStep.disabled  = false;

	return {
		steps,
		next,
	}
}




// WEBPACK FOOTER //
// ./src/containers/postevent/logic/wizard.js